export const CUSTOM_PG_EVENTS = ['game_opened', 'session_start', 'ping', 'navigation', 'session_end'] as const
export const SURVEY_PG_EVENTS = ['survey_game_completed'] as const

export const DEFAULT_CLIDS = { direct: 'direct', directTest: 'direct-test' }

export const MANIFEST_META_KEY = 'pwa-manifest'
